import React, { Component } from 'react';
import {  DropdownItem, DropdownMenu, DropdownToggle, Nav } from 'reactstrap';
import PropTypes from 'prop-types';

import {  AppHeaderDropdown,AppSidebarToggler} from '@coreui/react';
import './Style.scss'
import * as actionCreator from "../../store/Action";
import {connect} from "react-redux";
import image from "../../assets/img/logos/md-logo.png";

const propTypes = {
  children: PropTypes.node,
};

const defaultProps = {};

class HRHeader extends Component {

  render() {
    return (
      <React.Fragment>
        <AppSidebarToggler className="d-lg-none" display="md" mobile />
        <h1 className={"logo-text"}>
          {/*<span style={{color:'#53bd52'}}>#</span>tags*/}
          <img src={image} className={"logo-main"} alt="."/>
        </h1>

        {/*<Button animated className={this.props.system_changer === 1 ? "select-btn" : "unselect-btn"} onClick={()=>this.changeSystem(1)}>*/}
          {/*<Button.Content visible>*/}
            {/*<img src={tag_logo} alt={"."} className={"logos"}/>&nbsp;Tags*/}
          {/*</Button.Content>*/}
          {/*<Button.Content hidden>*/}
            {/*<img src={tag_logo} alt={"."} className={"logos"}/>&nbsp;*/}
            {/*<Icon name='arrow down' />*/}
          {/*</Button.Content>*/}
        {/*</Button>*/}

        <Nav className="ml-auto" navbar>
          <AppHeaderDropdown direction="down">
            <DropdownToggle nav>
              <span style={{
                fontSize: '16px',
                color: '#585858',
                fontWeight: '600',
                marginRight:'10px'
              }}>{this.props.usr_obj === undefined ? "Welcome admin" : "Welcome " + this.props.usr_obj.fullName}
                &nbsp;
                <i className="fa fa-caret-down"/>
              </span>
              {/*<img src={usrProPic} className="img-avatar" alt="..."/>*/}
            </DropdownToggle>
            <DropdownMenu right style={{ right: 'auto' }}>
              <DropdownItem onClick={e => this.props.onLogout(e)}><i className="fa fa-lock"/> Logout</DropdownItem>
            </DropdownMenu>
          </AppHeaderDropdown>
        </Nav>
      </React.Fragment>
    );
  }
}

HRHeader.propTypes = propTypes;
HRHeader.defaultProps = defaultProps;

const mapStateToProps = (state) => ({
  history: state.historyReducer.history,
  system_changer: state.systemChangeReducer.system_changer,
  usr_obj: state.userReducer.user,
  // dashboard count ---
  branchCount: state.COPAdminReducer.branchCount,
  departmentCount: state.COPAdminReducer.departmentCount,
  buildingsCount: state.COPAdminReducer.buildingsCount,
});

const mapDispatchToProps = (dispatch) => {
  return {
    systemChangeHandler: (data) => dispatch(actionCreator.systemChangeHandler(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HRHeader);
